import styled from '@emotion/styled';
import React from 'react';
import { ListContainer } from './styles';

const ChampionshipCardSkeleton = styled.div`
  border-radius: 8px;
  height: 128px;
`;

const PaginationContentSkeleton = styled.div`
  border-radius: 8px;
  width: 216px;
  height: 24px;
`;

type ChampionshipsListSkeletonProps = {
  resultsOnPage?: number;
  className?: string;
};

const ChampionshipsListSkeleton = ({ resultsOnPage = 9, className }: ChampionshipsListSkeletonProps) => {
  const items = new Array(resultsOnPage).fill('');

  return (
    <ListContainer className={`w-full px-6 ${className}`}>
      <div className="grid grid-cols-12 gap-3">
        {items.map((item, index) => (
          <div key={index} className="col-span-4">
            <ChampionshipCardSkeleton className="skeleton-block" />
          </div>
        ))}
      </div>
    </ListContainer>
  );
};

const PaginationSkeleton = () => {
  return (
    <div className="my-8 flex justify-start px-6">
      <PaginationContentSkeleton className="skeleton-block" />
    </div>
  );
};

type ChampionshipsBodySkeletonProps = ChampionshipsListSkeletonProps;

export const ChampionshipsBodySkeleton = ({ resultsOnPage, className }: ChampionshipsBodySkeletonProps) => {
  return (
    <>
      <ChampionshipsListSkeleton resultsOnPage={resultsOnPage} className={className || ''} />
      <PaginationSkeleton />
    </>
  );
};
